type SignalIconProps = {
  color?: string;
  size?: number | string;
};

export const SignalIcon = ({ color = 'currentColor', size = 16 }: SignalIconProps): JSX.Element => (
  <svg style={{ color }} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8284 5.17157C12.3905 6.73366 12.3905 9.26632 10.8284 10.8284M5.17157 10.8284C3.60947 9.2663 3.60947 6.73364 5.17157 5.17154M3.28595 12.714C0.682458 10.1105 0.682458 5.88944 3.28595 3.28595M12.714 3.28598C15.3175 5.88948 15.3175 10.1106 12.714 12.7141M9.33333 7.99999C9.33333 8.73637 8.73638 9.33333 8 9.33333C7.26362 9.33333 6.66667 8.73637 6.66667 7.99999C6.66667 7.26361 7.26362 6.66666 8 6.66666C8.73638 6.66666 9.33333 7.26361 9.33333 7.99999Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
